import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=d0b6dcda&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=d0b6dcda&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b6dcda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0b6dcda')) {
      api.createRecord('d0b6dcda', component.options)
    } else {
      api.reload('d0b6dcda', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=d0b6dcda&scoped=true", function () {
      api.rerender('d0b6dcda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/NotFound.vue"
export default component.exports